export default "__VITE_ASSET__ab3e4f82__"